// func not to create a new link on default callback param
export var noop = function () { return false; };
